import React from "react";

const PromotionContent = ({ children, onContinue, className = "" }) => {
  return (
    <div className={`promotion-content ${className}`}>
      {children}
      <button onClick={onContinue}>
        <strong>Continue</strong>
      </button>
    </div>
  );
};

export default PromotionContent;
